export default __webpack_public_path__ + "images/PW.c7caff6.png";